:host {
  display: block;
}

.is-hidden {
  display: none;
}

.pds-dropdown-menu--panel {
  background-color: var(--pine-color-background-overlay);
  border-radius: var(--pine-dimension-xs);
  left: var(--pine-dimension-none);
  min-width: 170px;
  padding: var(--pine-dimension-xs);
  position: fixed;
  z-index: var(--pine-z-index-overlay);

  :host-context([data-theme="dark"]) & {
    border: var(--pine-border);
  }
}

// Styles for raw <a> and <button> elements slotted into the menu
// These are allowed for edge cases requiring native browser/framework behavior
// (e.g., Rails UJS, Turbo) that cannot work through Shadow DOM.
//
// Note: ::slotted() cannot be combined with pseudo-classes like :hover or :focus.
// Raw elements will receive base styling here; hover/focus states must be handled
// by the consuming application's CSS if needed.
::slotted(a),
::slotted(button) {
  align-items: center;
  appearance: none;
  background: transparent;
  border: 0;
  border-radius: var(--pine-dimension-xs) !important;
  box-sizing: border-box;
  color: var(--pine-color-text) !important;
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  font: var(--pine-typography-body-medium) !important;
  gap: var(--pine-dimension-xs);
  margin: calc(var(--pine-border-width) + 2px) !important;
  padding: var(--pine-dimension-xs) !important;
  text-align: start;
  text-decoration: none !important;
  width: calc(100% - calc(var(--pine-border-width) + 2px) * 2);
}

// Destructive variant for raw elements
::slotted(.destructive) {
  color: var(--pine-color-danger) !important;
}

// Disabled state for raw elements (using attribute selectors, not pseudo-classes)
// ::slotted([disabled]) is an attribute-presence selector — it matches even when
// disabled="false" is set as a string (e.g. by React on custom elements). The
// :not([disabled="false"]) guard ensures only a truly-disabled attribute applies.
::slotted([aria-disabled="true"]),
::slotted([disabled]:not([disabled="false"])) {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
